// Option lists for CampaignEditForm's chip-multiselect fields. Values are the
// canonical lowercase strings the BE validates against (same values already
// stored on Campaign — see CampaignDetailsTab's `.map(titleCase)` display
// pattern) — mirrors apps/brand/src/dashboard/NewCampaign/constants.ts, kept
// as a lightweight local copy since packages/ui can't import from an app.

export const PRIMARY_GOAL_OPTIONS = [
  { value: 'product_launch', label: 'Product Launch' },
  { value: 'brand_awareness', label: 'Brand Awareness' },
  { value: 'lead_generation', label: 'Lead Generation' },
  { value: 'sales', label: 'Drive Sales' },
  { value: 'engagement', label: 'Engagement' },
];

export const PAYOUT_MODEL_OPTIONS = [
  { value: 'fixed_fee', label: 'Fixed Fee' },
  { value: 'revenue_share', label: 'Revenue Share' },
  { value: 'gifting_only', label: 'Gifting Only' },
];

export const CREATOR_CATEGORY_OPTIONS = [
  'finance',
  'business',
  'tech',
  'lifestyle',
  'health',
  'education',
  'beauty',
  'food',
  'travel',
];

export const TIER_OPTIONS = [
  { value: '1000-10000', label: '1K – 10K (Nano)' },
  { value: '10000-50000', label: '10K – 50K (Micro)' },
  { value: '50000-100000', label: '50K – 100K (Macro)' },
  { value: '100000-500000', label: '100K – 500K (Mid-tier)' },
  { value: '500000-1000000', label: '500K – 1M (Mega)' },
  { value: '1000000-10000000', label: '1M+ (Celebrity)' },
];

export const REGION_OPTIONS = ['india', 'usa', 'uae', 'uk'];
export const GENDER_OPTIONS = ['male', 'female', 'non-binary'];
export const LANGUAGE_OPTIONS = [
  'english',
  'hindi',
  'tamil',
  'telugu',
  'kannada',
  'malayalam',
  'bengali',
  'marathi',
  'gujarati',
  'arabic',
  'spanish',
];
